import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Legend,
  CategoryScale,
  BarElement,
  PointElement,
  Title,
} from "chart.js";
import ChartDataLabels from "chartjs-plugin-datalabels";

ChartJS.register(
  ArcElement,
  CategoryScale,
  PointElement,
  BarElement,
  Title,
  Tooltip,
  Legend,
  ChartDataLabels
);

interface ILeaderAvatarProps {
  labels: string[];
  data: number[];
}

const LeaderAvatar = ({
  labels,
  data,
}: ILeaderAvatarProps) => {

  const barData = {
    labels: labels,
    datasets: [
      {
        data: data,
        backgroundColor: [
          "rgba(255, 99, 132, 1)",
          "rgba(54, 162, 235, 1)",
          "rgba(255, 206, 86, 1)",
          "rgba(75, 192, 192, 1)",
          "rgba(153, 102, 255, 1)",
        ],
        borderColor: [
          "rgba(255, 99, 132, 1)",
          "rgba(54, 162, 235, 1)",
          "rgba(255, 206, 86, 1)",
          "rgba(75, 192, 192, 1)",
          "rgba(153, 102, 255, 1)",
        ],
        borderWidth: 1,
        borderRadius: 1000,
      },
    ],
  };

  const leaderAvatarOptions = {
    plugins: {
      datalabels: {
        display: true,
        color: "black",
        formatter: Math.round,
        anchor: "end" as const,
        offset: -20,
        align: "start" as const,
      },
      legend: {
        display: false,
      },
    },
    scales: {
      x: {
        grid: {
          display: false,
        },
      },
      y: {
        grid: {
          display: false,
        },
      },
    },
    barPercentage: 0.09,
    categoryPercentage: 0.9,
  };

  return (
    <div className="flex items-end justify-center gap-x-8">
      <Bar data={barData} options={leaderAvatarOptions} />

      {/* Second place
      {second && (
        <div className="flex flex-col items-center gap-y-4">
          <img
            src={getAvatarUrl(second)}
            alt={second.fullName}
            className="w-[125px] h-[125px] rounded-full border-4 border-neutral-300"
          />
          <div className="text-center">
            <p className="text-[24px] font-bold">2</p>
            <p className="text-[24px]">
              {second.expand?.user?.username || second.fullName}
            </p>
            <p className="text-lg text-neutral-600">{second.score} pts</p>
          </div>
        </div>
      )}

      {first && (
        <div className="flex flex-col items-center gap-y-4">
          <img
            src={getAvatarUrl(first)}
            alt={first.fullName}
            className="w-[200px] h-[200px] rounded-full border-4 border-yellow-400"
          />
          <div className="text-center">
            <p className="text-[24px] font-bold">1</p>
            <p className="text-[24px]">
              {first.expand?.user?.username || first.fullName}
            </p>
            <p className="text-lg text-neutral-600">{first.score} pts</p>
          </div>
        </div>
      )}

      {third && (
        <div className="flex flex-col items-center gap-y-4">
          <img
            src={getAvatarUrl(third)}
            alt={third.fullName}
            className="w-[125px] h-[125px] rounded-full border-4 border-orange-300"
          />
          <div className="text-center">
            <p className="text-[24px] font-bold">3</p>
            <p className="text-[24px]">
              {third.expand?.user?.username || third.fullName}
            </p>
            <p className="text-lg text-neutral-600">{third.score} pts</p>
          </div>
        </div>
      )} */}
    </div>
  );
};

export default LeaderAvatar;
